import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

const breakpoint = window.matchMedia( '(min-width:996px)' );

let instaFeed;

const breakpointChecker = function() {

    // if larger viewport and multi-row layout needed
    if ( breakpoint.matches === true ) {

        // clean up old instances and inline styles when available
        if ( instaFeed !== undefined ) instaFeed.destroy( true, true );

        // or/and do nothing
        return;

        // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === false ) {

        // fire small viewport version of swiper
        return enableSwiper();

    }

};

const enableSwiper = function() {

    let instaSlider = document.querySelectorAll('[js-insta-slider]');
    if(instaSlider.length > 0) {
        instaFeed = new Swiper('[js-insta-slider]', {
            slidesPerView: 1.25,
            centeredSlides: false,
            spaceBetween: 40,
            grabCursor: true,
            breakpoints: {
                // when window width is >= 320px
                576: {
                    slidesPerView: 2
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3
                },
                // when window width is >= 640px
                992: {
                    slidesPerView: 4
                },
            }
        });
    }
}

// keep an eye on viewport size changes
breakpoint.addListener(breakpointChecker);

// kickstart
breakpointChecker();
